import { render, staticRenderFns } from "./noticia-detalle.vue?vue&type=template&id=56bef416"
import script from "./noticia-detalle.vue?vue&type=script&lang=js"
export * from "./noticia-detalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports